angular.module('app')
    .service('plansApi', plansApi);

plansApi.$inject = [
    '$resource',
    'settings',
];

function plansApi(
    $resource,
    settings
) {
    const resource = $resource(`${settings.apiBase}/plans`);
    return resource;
}
